'use strict'
exports.default = {
  common: {
    zh: '简体中文',
    tw: '繁體中文',
    ja: '日本語',
    en: 'English',
    ko: '한국어',
    title: '后台管理系统',
    exit: '退出'
  }
}



// WEBPACK FOOTER //
// ./src/local/zh_tw.js